<template>
  <div>
    <PersonInfo :v="v" />

    <Assignee :v="v.assignee" :label="TrusteeLabel.PERSON" />
  </div>
</template>

<script>
import PersonInfo, {
  personInfoModel,
  personInfoValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Person/PersonInfo';
import Assignee, {
  assigneeModel,
  getAssigneeValidation,
} from '@/components/services/EgrnConfirm/Applicant/components/Assignee';
import cloneDeep from 'clone-deep';
import { TrusteeLabel } from '@/constants';

export const mrpaEnableAssigneePersonModel = {
  ...cloneDeep(personInfoModel),
  isTrustee: true,
  assignee: cloneDeep(assigneeModel),
};

export const getMrpaEnableAssigneePersonValidation = (person) => {
  const personValidation = {
    ...personInfoValidation,
    isTrustee: {},
  };

  personValidation.assignee = getAssigneeValidation(person.assignee);

  return personValidation;
};

export default {
  name: 'MrpaEnableAssigneePerson',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    PersonInfo,
    Assignee,
  },
  data: () => ({
    TrusteeLabel,
  }),
};
</script>
